export const ApiDoc = (flujax) => ({
  async getCustomerDoc (customerId) {
    return flujax.get(`/openapi/docs/${customerId}`)
  },
  async testEndpoint (path, data, method) {
    return flujax[method](path, data, { returnFullResponse: true, returnErrors: true, headers: { 'Content-Type': 'application/json' } })
  }
})
